// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/team.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import { TeamService } from "./team_pb";

/**
 * @generated from rpc chalk.server.v1.TeamService.GetEnv
 */
export const getEnv = TeamService.method.getEnv;

/**
 * @generated from rpc chalk.server.v1.TeamService.GetEnvIncludingArchived
 */
export const getEnvIncludingArchived = TeamService.method.getEnvIncludingArchived;

/**
 * @generated from rpc chalk.server.v1.TeamService.GetEnvironments
 */
export const getEnvironments = TeamService.method.getEnvironments;

/**
 * @generated from rpc chalk.server.v1.TeamService.GetAgent
 */
export const getAgent = TeamService.method.getAgent;

/**
 * @generated from rpc chalk.server.v1.TeamService.GetDisplayAgent
 */
export const getDisplayAgent = TeamService.method.getDisplayAgent;

/**
 * @generated from rpc chalk.server.v1.TeamService.GetTeam
 */
export const getTeam = TeamService.method.getTeam;

/**
 * @generated from rpc chalk.server.v1.TeamService.CreateTeam
 */
export const createTeam = TeamService.method.createTeam;

/**
 * @generated from rpc chalk.server.v1.TeamService.CreateProject
 */
export const createProject = TeamService.method.createProject;

/**
 * @generated from rpc chalk.server.v1.TeamService.UpdateProject
 */
export const updateProject = TeamService.method.updateProject;

/**
 * @generated from rpc chalk.server.v1.TeamService.ArchiveProject
 */
export const archiveProject = TeamService.method.archiveProject;

/**
 * @generated from rpc chalk.server.v1.TeamService.CreateEnvironment
 */
export const createEnvironment = TeamService.method.createEnvironment;

/**
 * @generated from rpc chalk.server.v1.TeamService.UpdateEnvironment
 */
export const updateEnvironment = TeamService.method.updateEnvironment;

/**
 * @generated from rpc chalk.server.v1.TeamService.CreateVectorDBConfiguration
 */
export const createVectorDBConfiguration = TeamService.method.createVectorDBConfiguration;

/**
 * @generated from rpc chalk.server.v1.TeamService.GetAvailablePermissions
 */
export const getAvailablePermissions = TeamService.method.getAvailablePermissions;

/**
 * @generated from rpc chalk.server.v1.TeamService.CreateServiceToken
 */
export const createServiceToken = TeamService.method.createServiceToken;

/**
 * @generated from rpc chalk.server.v1.TeamService.CreateServiceTokenTeamScoped
 */
export const createServiceTokenTeamScoped = TeamService.method.createServiceTokenTeamScoped;

/**
 * @generated from rpc chalk.server.v1.TeamService.UpdateServiceTokenTeamScoped
 */
export const updateServiceTokenTeamScoped = TeamService.method.updateServiceTokenTeamScoped;

/**
 * @generated from rpc chalk.server.v1.TeamService.DeleteServiceTokenTeamScoped
 */
export const deleteServiceTokenTeamScoped = TeamService.method.deleteServiceTokenTeamScoped;

/**
 * @generated from rpc chalk.server.v1.TeamService.ListServiceTokensTeamScoped
 */
export const listServiceTokensTeamScoped = TeamService.method.listServiceTokensTeamScoped;

/**
 * @generated from rpc chalk.server.v1.TeamService.DeleteServiceToken
 */
export const deleteServiceToken = TeamService.method.deleteServiceToken;

/**
 * @generated from rpc chalk.server.v1.TeamService.ListServiceTokens
 */
export const listServiceTokens = TeamService.method.listServiceTokens;

/**
 * @generated from rpc chalk.server.v1.TeamService.UpdateServiceToken
 */
export const updateServiceToken = TeamService.method.updateServiceToken;

/**
 * @generated from rpc chalk.server.v1.TeamService.InviteTeamMember
 */
export const inviteTeamMember = TeamService.method.inviteTeamMember;

/**
 * @generated from rpc chalk.server.v1.TeamService.InviteTeamMemberWithTeamRole
 */
export const inviteTeamMemberWithTeamRole = TeamService.method.inviteTeamMemberWithTeamRole;

/**
 * @generated from rpc chalk.server.v1.TeamService.ExpireTeamInvite
 */
export const expireTeamInvite = TeamService.method.expireTeamInvite;

/**
 * @generated from rpc chalk.server.v1.TeamService.ListTeamInvites
 */
export const listTeamInvites = TeamService.method.listTeamInvites;

/**
 * @generated from rpc chalk.server.v1.TeamService.ListTeamMembers
 */
export const listTeamMembers = TeamService.method.listTeamMembers;

/**
 * @generated from rpc chalk.server.v1.TeamService.UpsertFeaturePermissions
 */
export const upsertFeaturePermissions = TeamService.method.upsertFeaturePermissions;

/**
 * @generated from rpc chalk.server.v1.TeamService.UpdateScimGroupSettings
 */
export const updateScimGroupSettings = TeamService.method.updateScimGroupSettings;

/**
 * @generated from rpc chalk.server.v1.TeamService.GetTeamPermissions
 */
export const getTeamPermissions = TeamService.method.getTeamPermissions;

/**
 * @generated from rpc chalk.server.v1.TeamService.GetPermissionsForEnvironment
 */
export const getPermissionsForEnvironment = TeamService.method.getPermissionsForEnvironment;

/**
 * @generated from rpc chalk.server.v1.TeamService.ArchiveEnvironment
 */
export const archiveEnvironment = TeamService.method.archiveEnvironment;

/**
 * Chalk-employee-only: PERMISSION_CHALK_ADMIN is injected into a user agent
 * only for an @chalk.ai address, and no role grants it, so a customer cannot
 * reach this even as the owner of their own team. A service token can only
 * carry it if a Chalk employee deliberately minted one with it --
 * CreateServiceToken requires the permission to be a subset of the caller's
 * own, and GetAvailablePermissions does not offer it in the UI.
 *
 * @generated from rpc chalk.server.v1.TeamService.DeleteSelfSignupTeam
 */
export const deleteSelfSignupTeam = TeamService.method.deleteSelfSignupTeam;

/**
 * @generated from rpc chalk.server.v1.TeamService.DeactivateUser
 */
export const deactivateUser = TeamService.method.deactivateUser;

/**
 * @generated from rpc chalk.server.v1.TeamService.ReactivateUser
 */
export const reactivateUser = TeamService.method.reactivateUser;

/**
 * Assigns a team-scoped role to a user (i.e. role assignment with no environment).
 *
 * @generated from rpc chalk.server.v1.TeamService.AssignTeamRole
 */
export const assignTeamRole = TeamService.method.assignTeamRole;

/**
 * Assigns an environment-scoped role to a user.
 *
 * @generated from rpc chalk.server.v1.TeamService.AssignEnvironmentRole
 */
export const assignEnvironmentRole = TeamService.method.assignEnvironmentRole;

/**
 * Assigns an environment-scoped role to a SCIM group.
 *
 * @generated from rpc chalk.server.v1.TeamService.AssignScimGroupEnvironmentRole
 */
export const assignScimGroupEnvironmentRole = TeamService.method.assignScimGroupEnvironmentRole;

/**
 * @generated from rpc chalk.server.v1.TeamService.DeleteScimGroup
 */
export const deleteScimGroup = TeamService.method.deleteScimGroup;

/**
 * @generated from rpc chalk.server.v1.TeamService.DeleteScimGroupUsers
 */
export const deleteScimGroupUsers = TeamService.method.deleteScimGroupUsers;

/**
 * @generated from rpc chalk.server.v1.TeamService.CreateCustomRole
 */
export const createCustomRole = TeamService.method.createCustomRole;

/**
 * @generated from rpc chalk.server.v1.TeamService.DeleteCustomRole
 */
export const deleteCustomRole = TeamService.method.deleteCustomRole;

/**
 * @generated from rpc chalk.server.v1.TeamService.UpdateCustomRole
 */
export const updateCustomRole = TeamService.method.updateCustomRole;

/**
 * @generated from rpc chalk.server.v1.TeamService.GetProject
 */
export const getProject = TeamService.method.getProject;
